import React, { Fragment } from "react";
import { Loading } from "./Loading";
import axios from "axios";

import { connect } from "react-redux";
import {createUser, loadStatus, logOutUser} from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";

import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BASE_URL } from "../constant";
import Loader from "react-loader-spinner";
import SimpleReactValidator from "simple-react-validator";
import { NetworkError } from "./NetworkError";
import {endpoints, http} from "../configs/https";

class Umoomi extends React.Component {
  constructor() {
    super();
    this.state = {
      jummat: "",
      eid: "",
      ijtema: "",
      jalsa: "",
      other: "",
      report_sent: "",

      special_squad: 0,
      training: 0,
      attendance: 0,
      driver: 0,
      nycn1: "",
      nycn2: 0,
      isSubmitting: false,
      submitted: false,
      loading: true,

      month: 0,
      networkError: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // mod.modal('show');
    document.title = "UMOOMI - MKAN REPORT";
    this.setupValidator();
  }
  setupValidator() {
    this.setState({
      loading: false
    });
    const {year, month} = this.props.monthYear;
    const {failed} = this.props.status;
    if (failed) {
      this.props.loadStatus(month, year);
    }
    this.validator = new SimpleReactValidator();
  }


  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  }
  handleSubmit(event) {
    event.preventDefault();
    const { month, year, monthName } = this.props.monthYear;
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
      return;
    }
    Swal.fire({
      title:
        "Are you sure you want to submit your umoomi report for " +
        monthName +
        " " +
        year +
        "?",
      text:
        "You won't be able to revert this after submitting, kindly check all details are accurate.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33"
    }).then(result => {
      if (result.value) {
        this.setState({
          isSubmitting: true
        });

        this.LoadingBar.staticStart(15);

        http
          .post(
            endpoints.GENERAL,
            {
              jummat: this.state.jummat === "Yes",
              eid: this.state.eid === "Yes",
              ijtema: this.state.ijtema === "Yes",
              jalsa: this.state.jalsa === "Yes",
              other: this.state.other === "Yes",
              report_sent: this.state.report_sent === "Yes",
              special_squad: this.state.special_squad,
              training: this.state.training,
              attendance: this.state.attendance,
              driver: this.state.driver,
              nycn1: this.state.nycn1,
              nycn2: this.state.nycn2,
              month: month,
              year: year
            },
          )
          .then(res => {
            if (res.status !== 201) {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "warning",
                title: "There is an error in your submission, try again"
              });
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "success",
                title: "Umoomi report submitted successfully "
              });

              this.LoadingBar.complete();
              this.setState({
                isSubmitting: false
              });
              this.props.loadStatus(month,year);
            }
          })
            .catch(error => {
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
              let errorMessage =
                  (typeof error === "string" && error) ||
                  "An error occured, please try again in a moment.";

              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "error",
                title: errorMessage
              });
              // alert(JSON.stringify(error));
              console.log(errorMessage);
            });
      }
    });
  }
  render() {
    const { year, monthName } = this.props.monthYear;
    const {data, isFetching, failed} = this.props.status;
    const {isSubmitting} = this.state;
    return (
      <div>
        {this.state.networkError || failed ? (
          <NetworkError />
        ) : (
          <section className="content">
            {this.state.loading ||isFetching ? (
              <div>
                <div className="spinner">
                  <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height="40"
                    width="40"
                  />
                </div>
              </div>
            ) : (
              <div>
                {!data.general ? (
                  <div>
                    <LoadingBar onRef={ref => (this.LoadingBar = ref)} />
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header card-header-primary">
                            <h4 className="card-title">
                              UMOOMI (SPECIAL DUTIES) - {monthName}
                              , {year}
                            </h4>
                            <p className="card-category">
                              Complete the form below
                            </p>
                          </div>

                          <div className="card-body">
                            <form onSubmit={this.handleSubmit}>
                              <div className="row myborder">
                                <div className="col-md-12 mycenter">
                                  <h2>
                                    Whether Khuddam of Majlis offer services as
                                    security guard during Jamaat ceremonies like
                                    Friday Prayer, Id, Ijtema , other meetings
                                    etc.
                                  </h2>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Jummat
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id="jummat"
                                          onChange={this.handleChange}
                                          name="jummat"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id="organized"
                                          onChange={this.handleChange}
                                          name="jummat"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "Jummat",
                                        this.state.jummat,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Eid
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id="eid"
                                          onChange={this.handleChange}
                                          name="eid"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="eid"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "Eid",
                                        this.state.eid,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Ijtema
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="ijtema"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="ijtema"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "ijtema",
                                        this.state.ijtema,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Jalsa
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="jalsa"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="jalsa"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "jalsa",
                                        this.state.jalsa,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Others
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="other"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="other"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "other",
                                        this.state.other,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="row mt-5">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Was separate report of the department
                                      sent?
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="report_sent"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="report_sent"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "report",
                                        this.state.report_sent,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No of khuddam on special squad{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="phoner"
                                      min="0"
                                      name="special_squad"
                                      value={this.state.special_squad}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "no of kduddam on special squad",
                                      this.state.special_squad,
                                      "required"
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No of security training held{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      min="0"
                                      name="training"
                                      value={this.state.training}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "training",
                                      this.state.training,
                                      "required"
                                    )}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No of khuddam in attendance{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      min="0"
                                      name="attendance"
                                      value={this.state.attendance}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "attendance",
                                      this.state.attendance,
                                      "required"
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No of khuddam who can drive{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      min="0"
                                      name="driver"
                                      value={this.state.driver}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "khuddam who can drive",
                                      this.state.driver,
                                      "required"
                                    )}
                                  </span>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Is your Qaidat registered with the NYCN?
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="nycn1"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="nycn1"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                    <span className="text-danger">
                                      {this.validator.message(
                                        "report",
                                        this.state.nycn1,
                                        "required"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Attendance at regular NYCN meetings{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      min="0"
                                      name="driver"
                                      value={this.state.nycn2}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "attendance",
                                      this.state.nycn2,
                                      "required"
                                    )}
                                  </span>
                                </div>
                              </div>

                              {isSubmitting ? <Loading /> : ""}

                              <button
                                type="submit"
                                className="btn btn-success pull-right"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? "Loading..." : "Submit"}
                              </button>
                              <div className="clearfix" />
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div />
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <h2>
                      You already submitted UMOOMI report for{" "}
                      <b>
                        {monthName}, {year}
                      </b>
                    </h2>
                  </div>
                )}
              </div>
            )}
          </section>
        )}
      </div>
    );
  }
}

Umoomi.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear,
  status: state.status,
});

export default connect(mapStateToProps, { createUser, logOutUser, loadStatus })(Umoomi);
